import type { FunctionComponent } from "react";
import { Button } from "@kanda-libs/ks-design-library";
import CompanyVerifyModal from "components/company/CompanyVerifyModal";

export interface CompanyVerifyButtonProps {
  showVerifyModal: () => void;
  isSubmitting: boolean;
}

const CompanyDeclineButton: FunctionComponent<CompanyVerifyButtonProps> =
  function ({ showVerifyModal, isSubmitting }) {
    return (
      <>
        <Button.Text
          id="verify-company"
          onClick={showVerifyModal}
          label="Verify company"
          size={40}
          className="mb-6"
          disabled={isSubmitting}
        />
        <CompanyVerifyModal />
      </>
    );
  };

export default CompanyDeclineButton;
